import qs from 'qs'
import {
  checkHttpStatus,
  getApiBaseUrl,
  getApiBaseUrlWithOrg,
  getApiHeadersFromToken
} from '../../../../utils/api'

export const fetchFrameworkSkills = async (
  apiData,
  frameworkSubjectId,
  gradeLevelId
) => {
  const params = qs.stringify(
    {
      q: {
        grade_level_id_eq: gradeLevelId
      }
    },
    { arrayFormat: 'brackets', encode: false }
  )

  const url = `${getApiBaseUrl()}/api/framework_subjects/${frameworkSubjectId}/framework_skills_framework?${params}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    const res = await response.json()
    return res
  } catch (err) {
    throw err
  }
}

export const fetchFocusSkillGuidance = async (
  apiData,
  activityId,
  frameworkSkillId
) => {
  const params = qs.stringify({
    q: {
      activity_id_eq: activityId
    }
  })

  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/framework_skills/${frameworkSkillId}/activity_focus_skill_guidances?${params}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    const res = await response.json()
    return res
  } catch (err) {
    throw err
  }
}

export const fetchFocusSkills = async (apiData, focusSkillsContext) => {
  try {
    const params = qs.stringify({
      q: {
        level_id_eq: focusSkillsContext.levelId,
        quest_id_eq: focusSkillsContext.questId
      }
    })

    const url = `${getApiBaseUrlWithOrg(apiData.orgId)}/course_sections/${
      focusSkillsContext.courseSectionId
    }/activity_focus_skills?${params}`

    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
    const res = await response.json()
    return res
  } catch (err) {
    throw err
  }
}

export const mutateFocusSkill = async (
  apiData,
  focusSkillsContext,
  focusSkill,
  applyToAllSections = false,
  frameworkSkillId,
  studentGuidance = null
) => {
  try {
    let url = `${getApiBaseUrlWithOrg(apiData.orgId)}/mentor/course_sections/${
      focusSkillsContext.courseSectionId
    }/levels/${focusSkillsContext.levelId}/activity_focus_skills`

    if (focusSkill) {
      url += '/' + focusSkill.id
    }

    const response = checkHttpStatus(
      await fetch(url, {
        method: focusSkill ? 'PUT' : 'POST',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify({
          apply_to_all_sections: applyToAllSections,
          activity_focus_skill: {
            quest_id: focusSkillsContext.questId,
            activity_id: focusSkillsContext.activityId,
            framework_skill_id: frameworkSkillId,
            student_guidance: studentGuidance
          }
        })
      })
    )
    const res = await response.json()
    return res
  } catch (err) {
    throw err
  }
}

export const deleteFocusSkill = async (
  apiData,
  focusSkillsContext,
  focusSkill,
  applyToAllSections = false
) => {
  try {
    const url = `${getApiBaseUrlWithOrg(
      apiData.orgId
    )}/mentor/course_sections/${focusSkillsContext.courseSectionId}/levels/${
      focusSkillsContext.levelId
    }/activity_focus_skills/${focusSkill.id}`

    checkHttpStatus(
      await fetch(url, {
        method: 'DELETE',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify({
          apply_to_all_sections: applyToAllSections
        })
      })
    )
    return true
  } catch (err) {
    throw err
  }
}

export const deleteGuidance = async (
  apiData,
  frameworkSkillId,
  activityFocusSkillId,
  guidanceId
) => {
  try {
    const url = `${getApiBaseUrlWithOrg(
      apiData.orgId
    )}/mentor/framework_skills/${frameworkSkillId}/activity_focus_skill_guidances/${activityFocusSkillId}/remove_guidance`

    checkHttpStatus(
      await fetch(url, {
        method: 'PUT',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify({
          activity_focus_skill_guidances: {
            applied_guidance_id: guidanceId
          }
        })
      })
    )
  } catch (err) {
    throw err
  }
}
